<script>
import axios from 'axios';
//import Cookies from 'js-cookie';
import 'custom-event-polyfill';
//import '../Util/polyfills';

class UserLocation {
  longitude = 0;
  latitude = 0;
  state = '';
  city = '';
  zipCode = '';
  address = '';
  neighborhood = '';
  county = '';
  country = '';
  display = '';

  constructor() {}

  get valid() {
    return this.isValid();
  }

  isValid() {
    if (!this.latitude || !this.longitude) {
      return false;
    }

    const parsedLat = Number.parseFloat(this.latitude);
    if (!Number.isNaN(parsedLat) && parsedLat !== 0) {
      return true;
    }

    return false;
  }
}

function parseGoogleAddressToLocation(googleObject) {
  var loc = new UserLocation(),
    coords = false;

  if (!googleObject || !googleObject.geometry || !googleObject.address_components) {
    return loc;
  }

  coords = googleObject.geometry.location;

  loc.latitude = typeof coords.lat === 'function' ? coords.lat() : coords.lat;
  loc.longitude = typeof coords.lng === 'function' ? coords.lng() : coords.lng;
  loc.address = googleObject.formatted_address;

  for (var i = 0; i < googleObject.address_components.length; i++) {
    var component = googleObject.address_components[i];

    for (var x = 0; x < component.types.length; x++) {
      var type = component.types[x],
        value = component.short_name;

      switch (type) {
        case 'administrative_area_level_1':
          loc.state = value;
          break;

        case 'postal_code':
          loc.zipCode = value;
          break;

        case 'locality':
          loc.city = value;
          break;

        case 'administrative_area_level_2':
          loc.county = value;
          break;

        case 'neighborhood':
          loc.neighborhood = value;
          break;
          
        case 'country':
          loc.country = value;
          break;

        case 'political':
          loc.country = value;
          break;
      }
    }
  }

  loc.display = [loc.city, loc.state].filter(Boolean).join(', ').trim();

  return loc;
}

export default {
  props: {
    apiKey: {
      type: String,
      required: true,
    },
    prefix: {
      type: String,
      default: () => 'Using',
    },
    preciseLocation: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showLoader: true,
    initialized: false,
    browserSupportsGeolocation: !!navigator.geolocation && typeof navigator.geolocation.getCurrentPosition === 'function',
    currentLocation: new UserLocation(),
    typeahead: null,
    errorMessage: '',
    geocodeApiUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
    showForm: false,
  }),
  computed: {
    mapsScriptUrl: function () {
      return 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + this.apiKey;
    },
    geolocationApiUrl: function () {
      return 'https://www.googleapis.com/geolocation/v1/geolocate?key=' + this.apiKey;
    },
  },
  mounted() {
    let app = this;

    if (navigator.userAgent && /bot/gi.test(navigator.userAgent)) {
      console.warn('You are a bot, and bots do not have locations.  So, you are now transported to Johnston, Iowa.');
      
      app.showLoader = false;
      app.errorMessage = '';

      let johnstonIowa = new UserLocation();
      johnstonIowa.address = 'Johnston, IA, USA';
      johnstonIowa.city = 'Johnston';
      johnstonIowa.county = 'Polk County';
      johnstonIowa.display = 'Johnston, IA';
      johnstonIowa.latitude = 41.6709834;
      johnstonIowa.longitude = -93.7130493;
      johnstonIowa.neighborhood = '';
      johnstonIowa.state = 'IA';
      johnstonIowa.zipCode = '50131';

      this.saveLocation(johnstonIowa, 'Set for a robot.');
      return;
    }

    if (!document.querySelector('script[src="' + app.mapsScriptUrl + '"]')) {
      let mapsApiScript = document.createElement('script');
      mapsApiScript.id = 'google-maps-api';
      mapsApiScript.async = true;

      mapsApiScript.onload = () => {
        app.emitEvent('maps-api-script-loaded', 'loaded google maps script');
        app.setup();
      };

      mapsApiScript.onerror = (e) => {
        this.emitEvent('maps-api-script-load-error', 'unable to load google api script. google geolocation api unavailable.', new UserLocation(), e);
        this.initialized = false;
        this.showLoader = false;
        this.displayErrorMessage('Sorry, but we could not connect to the server.');
        this.showForm = true;
      };

      mapsApiScript.setAttribute('src', app.mapsScriptUrl);
      document.head.appendChild(mapsApiScript);
    } else {
      app.setup();
    }
  },
  methods: {
    setup: function () {
      // init the app here

      if (this.initialized) {
        console.warn('already initialized.  stopping this madness right here.');
        return;
      }

      //see https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
      var autoCompleteOptions = {
        componentRestrictions: { country: 'us' },
        types: ['geocode'],
        fields: ['geometry', 'address_components', 'formatted_address'],
        regions: ['locality', 'sublocality', 'postal_code'],
      };

      if (this.preciseLocation) {
        autoCompleteOptions.regions.push('street_address');
      }

      var googleMapsAvailable = typeof google !== 'undefined' && google.maps && google.maps.places;

      if (!googleMapsAvailable) {
        console.error('google geolocation api unavailable');
        return;
      }

      if (!this.$el) {
        console.error('no $el.  weird.');
        return;
      }

      //enter key listener
      function enableEnterKey(input) {
        /* Store original event listener */
        const _addEventListener = input.addEventListener;

        const addEventListenerWrapper = (type, listener) => {
          if (type === 'keydown') {
            /* Store existing listener function */
            const _listener = listener;
            listener = (event) => {
              /* Simulate a 'down arrow' keypress if no address has been selected */
              const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;
              if (event.key === 'Enter' && !suggestionSelected) {
                const e = new KeyboardEvent('keydown', {
                  key: 'ArrowDown',
                  code: 'ArrowDown',
                  keyCode: 40,
                });

                _listener.apply(input, [e]);
              }
              _listener.apply(input, [event]);
            };
          }
          _addEventListener.apply(input, [type, listener]);
        };

        input.addEventListener = addEventListenerWrapper;
      }

      var inputElement = this.$el.querySelector('.geolocation-control__placeSearch-input');
      this.typeahead = new google.maps.places.Autocomplete(inputElement, autoCompleteOptions);
      this.typeahead.addListener('place_changed', this.onPlaceSelected);

      //https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter

      //enter key listener on auto complete.
      //make sure this is AFTER place_changed
      enableEnterKey(inputElement);

      //check a saved location from localstorage or cookie
      //if not found, try from the IP address
      if (!this.loadSavedLocation()) {
        this.loadLocationFromAPI();
      }

      if (!this.browserSupportsGeolocation) {
        var compassElement = this.$el.querySelector('.geolocation-control__detectLocation-button');
        compassElement.style.opacity = '.25';
        compassElement.disabled = true;
      }

      this.initialized = true;
      this.showLoader = false;

      this.emitEvent('initialized', 'initialized geolocation component', null, null, inputElement);
    },

    emitEvent: function (eventName, message, location, error, element) {
      let eventObject = {
        eventName: 'event',
        eventGlobalName: 'geolocation',
        message: message || '',
        location: location || new UserLocation(),
      };

      if (error) {
        eventObject.error = error;
      }

      if (element && element.tagName) {
        eventObject.currentTarget = element;
      }

      if (eventName && eventName.length > 0) {
        eventObject.eventName = eventName.toLowerCase().replace(/[\W]{1,}/gi, '-');
      }

      eventObject.eventGlobalName += '-' + eventObject.eventName;

      this.$emit(eventObject.eventName, eventObject);

      this.$root.$emit(eventObject.eventGlobalName, eventObject);

      document.dispatchEvent(new CustomEvent(eventObject.eventGlobalName, eventObject));

      if ((error && typeof error !== 'undefined' && error !== null) || message.indexOf('error') > -1) {
        console.error(message, error);
      }
    },

    emitErrorEvent: function (message, error, element) {
      this.emitEvent('error', message, new UserLocation(), error, element);
    },

    displayErrorMessage: function (message) {
      const valid = message && message.length > 0;
      this.errorMessage = valid ? message : '';
    },
    clearErrorMessage: function () {
      this.errorMessage = '';
    },

    setLocationFromZipCode: function (zipCode) {
      var app = this;

      axios
        .get(app.geocodeApiUrl, {
          params: {
            //Ensure that no space exists between the component id and zip code
            components: 'postal_code:' + zipCode,
            key: app.apiKey,
          },
        })
        .then(function (response) {
          var data = response.data,
            loc = parseGoogleAddressToLocation(data.results[0]);

          if (data.status === 'ZERO_RESULTS') {
            app.emitEvent('not-found', 'Zip code not found.', false, data, false);
          }

          if (data.status !== 'OK') {
            app.displayErrorMessage('Sorry, we could not find your location.');
            let errorMsg = data.error_message || 'error setting location from zip code';

            app.emitEvent('error', errorMsg);
            return false;
          }

          if (loc.valid) {
            app.saveLocation(loc, 'Set from ZipCode');
          }
        })
        .catch(function (error) {
          app.displayErrorMessage('Zip code not found.');

          // (eventName, message, location, error, element)
          app.emitEvent('not-found', 'Zip code not found.', false, error, false);
        });
    },

    setLocationFromLatLong: function (latitude, longitude) {
      var app = this;

      app.clearErrorMessage();

      if (typeof latitude === 'undefined' || typeof longitude === 'undefined' || latitude === 0 || longitude === 0) {
        app.emitErrorEvent('coordinates-invalid', 'Lat/Long coordinate invalid.');
        return;
      }

      // const xhr = new XMLHttpRequest();
      // //xhr.overrideMimeType('application/json');
      // //xhr.responseType = 'text';
      // //xhr.withCredentials = true;
      // xhr.addEventListener('load', function (response) {
      //   // if (this.status != 200) {
      //   //   app.showForm = true;
      //   //   app.emitEvent('error', 'Could not load location from API. Status: ' + this.status + ' ' + this.statusText);
      //   //   return;
      //   // }

      //   // var loc = this.response.location,
      //   //   latitude = loc.lat,
      //   //   longitude = loc.lng;

      //   // app.setLocationFromLatLong(latitude, longitude);

      //   if (this.status !== 200) {
      //     app.emitErrorEvent('geocoding api error ' + this.response.error.status + ' ' + this.response.error.message);
      //     //app.displayErrorMessage("We're sorry, but we cannot locate you. " + response.data.status);
      //     app.showForm = true;
      //     return;
      //   }

      //   var loc = parseGoogleAddressToLocation(this.response.results[0]);

      //   app.showForm = false;
      //   app.saveLocation(loc, 'Saved from lat/long');
      // });
      // xhr.addEventListener('error', function (event) {
      //   // app.showForm = true;
      //   // app.emitEvent('warning', 'Could not automatically load location from API.');
      //   // console.info('Could not automatically load location from API.', event.type, event.target.status);

      //   app.emitErrorEvent('lat/long coordinate parsing error.',event.type + ' ' + event.target.responseText);
      //   //app.displayErrorMessage("We're sorry, but we cannot locate you");
      //   app.showForm = true;
      // });

      // //Ensure that no space exists between the latitude and longitude values when passed in the latlng parameter.
      // var params = '&latlng=' + latitude + ',' + longitude;

      // xhr.open('GET', app.geolocationApiUrl + params, true);
      // //xhr.setRequestHeader('X-PINGOTHER', 'pingpong');
      // //xhr.setRequestHeader('ccess-Control-Allow-Origin', '*');
      // xhr.send();

      axios
        .get(app.geocodeApiUrl, {
          params: {
            //Ensure that no space exists between the latitude and longitude values when passed in the latlng parameter.
            latlng: latitude + ',' + longitude,
            key: app.apiKey,
          },
        })
        .then(function (response) {
          var loc = parseGoogleAddressToLocation(response.data.results[0]);

          if (response.data.status !== 'OK') {
            app.emitErrorEvent('geocoding api error ' + response.data.error_message, response.data);
            //app.displayErrorMessage("We're sorry, but we cannot locate you. " + response.data.status);
            app.showForm = true;
            return;
          }
          app.showForm = false;
          app.saveLocation(loc, 'Saved from lat/long');
        })
        .catch(function (error) {
          app.emitErrorEvent('lat/long coordinate parsing error.', error);
          //app.displayErrorMessage("We're sorry, but we cannot locate you");
          app.showForm = true;
        });
    },

    saveLocation: function (location, message, sourceElement) {
      if (!location.valid) {
        this.showForm = true;
        this.emitErrorEvent('unable to save invalid location object', 'invalid location object', sourceElement);
        return false;
      }

      this.clearErrorMessage();

      this.currentLocation = location;
      if (localStorage) {
        localStorage.setItem('location', JSON.stringify(location));
      }
      // Cookies.set('location', JSON.stringify(location));
      // Cookies.set('zip', location.zipCode);
      // Cookies.set('latitude', location.latitude);
      // Cookies.set('latitude', location.longitude);

      this.emitEvent('change', message, location, false, sourceElement);

      this.showForm = false;
      return true;
    },

    loadSavedLocation: function () {
      //get from localStorage
      var location = new UserLocation(),
        locFromLS = false,
        //locFromCookie = JSON.parse(Cookies.get('location') || false),
        from = 'none',
        app = this;

      if (localStorage) {
        locFromLS = JSON.parse(localStorage.getItem('location') || false);
      }

      if (locFromLS) {
        //load from local storage
        Object.assign(location, locFromLS);
        from = 'localStorage';
      }
      // else if (locFromCookie) {
      //   //load from cookie
      //   Object.assign(location, locFromCookie);
      //   from = 'cookie';
      // }

      if (!location || !location.valid) {
        //location not saved - need to load from another source
        app.currentLocation = new UserLocation();
        if (app.initialized) {
          app.showForm = true;
        }
        return false;
      }

      app.emitEvent('change', 'Loaded from ' + from, location);

      app.currentLocation = location;

      app.clearErrorMessage();

      app.showForm = false;
      return true;
    },

    loadLocationFromAPI: function () {
      //LOADING LOCATION FROM IP
      var app = this;

      // const xhr = new XMLHttpRequest();
      // xhr.overrideMimeType('application/json');
      // xhr.responseType = 'json';
      // xhr.addEventListener('load', function (response) {
      //   if (this.status != 200) {
      //     app.showForm = true;
      //     app.emitEvent('error', 'Could not load location from API. Status: ' + this.status + ' ' + this.statusText);
      //     return;
      //   }

      //   var loc = this.response.location,
      //     latitude = loc.lat,
      //     longitude = loc.lng;

      //   app.setLocationFromLatLong(latitude, longitude);
      // });
      // xhr.addEventListener('error', function (event) {
      //   app.showForm = true;
      //   app.emitEvent('warning', 'Could not automatically load location from API.');
      //   console.info('Could not automatically load location from API.', event.type, event.target.status);
      // });
      // xhr.open('post', app.geolocationApiUrl);
      // xhr.send();

      axios
        .post(app.geolocationApiUrl, {
          params: {
            key: app.apiKey,
          },
        })
        .then(function (response) {
          var loc = response.data.location,
            latitude = loc.lat,
            longitude = loc.lng;

          app.setLocationFromLatLong(latitude, longitude);
        })
        .catch(function (error) {
          app.emitEvent('warning', 'Could not automatically load location from API.');
          console.info('Could not automatically load location from API.', error);
          app.showForm = true;
        });
    },

    askBrowserForLocation: function (e) {
      const compassElement = e.currentTarget || e.sourceElement,
        app = this;

      e.preventDefault();

      //OMG IE11 doesn't have classList on an SVG
      if (!compassElement.classList) {
        console.log('ie sucks');
        compassElement.classList = [];
      }

      if (!app.browserSupportsGeolocation) {
        console.warn('geolocation not available.');
        app.emitErrorEvent('browser does not support or allow geolocation', false, compassElement);
        return false;
      }
      compassElement.classList.add('processing');

      //timeout 1 sec
      var positionOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 1000,
      };

      //geolocation is available
      function success(position) {
        //LOADING COORDS FROM BROWSER
        compassElement.classList.remove('processing');
        app.setLocationFromLatLong(position.coords.latitude, position.coords.longitude);
      }

      function error(errorEvent) {
        let msg = 'Geolocation error.';
        compassElement.classList.remove('processing');
        compassElement.style.opacity = '.25';
        compassElement.disabled = true;

        switch (errorEvent.code) {
          case 1:
            msg = 'Location denied by browser';
            break;
          case 2:
            msg = 'Location unavailable';
            break;
          case 3:
            msg = 'Location timeout';
            break;
        }
        app.displayErrorMessage(msg);
        app.emitErrorEvent('browser position error. ' + msg, errorEvent, compassElement);
      }

      //ask the browser for it's location
      navigator.geolocation.getCurrentPosition(success, error, positionOptions);
    },

    //after the user selects a city from the google autocomplete
    //get the location details from google
    onPlaceSelected: function () {
      let place = this.typeahead.getPlace(),
        loc = parseGoogleAddressToLocation(place);

      this.clearErrorMessage();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.

        //maybe it's a zip?
        const isValidZip = place.name && /^[\d-]{5,10}$/gi.test(place.name.trim());

        if (isValidZip) {
          //looks like a zip code to me
          this.setLocationFromZipCode(place.name);
          return false;
        }

        this.emitEvent('not-found', 'No results found');

        this.displayErrorMessage('No results found.');
        return false;
      }

      if (this.preciseLocation) {
        loc.display = place.formatted_address.replace(', USA', '');
      }

      this.saveLocation(loc, 'Loaded from google place');
      return true;
    },
  },
};
</script>

<template>
  <div class="geolocation" v-bind:class="{loading: showLoader}" autocomplete="off">
    <div class="geolocation__loader" v-if="showLoader">
      <div class="ring-loader">
        <div class="ring-loader__circle">
          <div class="ring-loader__circle-quarter"></div>
          <div class="ring-loader__circle-quarter"></div>
          <div class="ring-loader__circle-quarter"></div>
          <div class="ring-loader__circle-quarter"></div>
        </div>
      </div>
    </div>
    <div class="geolocation__display" v-cloak v-show="!showForm && currentLocation.display.length > 0">
      <span class="geolocation__display-label">{{prefix}} {{currentLocation.display}}</span>
      <button class="geolocation__show-form" v-on:click="showForm = true;">Change</button>
    </div>
    <table class="geolocation-control" v-cloak v-show="showForm">
      <tbody>
        <tr>
          <td class="geolocation-control__placeSearch">
            <input
              id="@id"
              placeholder="City, State or Zip code"
              type="search"
              class="geolocation-control__placeSearch-input"
              maxlength="150"
              autocomplete="off"
              aria-label="Search"
              aria-haspopup="true"
              aria-autocomplete="both"
              dir="ltr"
              spellcheck="false"
            />
          </td>
          <td class="geolocation-control__detectLocation">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 421.28 421.28" id="crosshair" class="geolocation-control__detectLocation-button" v-on:click="askBrowserForLocation" alt="Use my location" title="Use my location">
              <polygon class="crosshair__border" points="36.64,42.8 36.64,129.84 52.64,129.84 52.64,58.8 128.08,58.8 128.08,42.8" />
              <polygon class="crosshair__border" points="293.2,42.8 293.2,58.8 368.64,58.8 368.64,129.84 384.64,129.84 384.64,42.8" />
              <polygon class="crosshair__border" points="52.64,361.04 52.64,289.92 36.64,289.92 36.64,377.04 128.08,377.04 128.08,361.04" />
              <polygon class="crosshair__border" points="368.64,289.92 368.64,361.04 293.2,361.04 293.2,377.04 384.64,377.04 384.64,289.92" />
              <rect class="crosshair__line" x="202.64" width="16" height="98.64" />
              <rect class="crosshair__line" x="202.64" y="322.64" width="16" height="98.64" />
              <rect class="crosshair__line" x="322.64" y="202.64" width="98.64" height="16" />
              <rect class="crosshair__line" y="202.64" width="98.64" height="16" />
              <path
                class="crosshair__center"
                d="M210.64 147.92c-34.639 0-62.72 28.081-62.72 62.72s28.081 62.72 62.72 62.72c34.639 0 62.72-28.081 62.72-62.72-.044-34.621-28.099-62.676-62.72-62.72zm0 109.44v.08c-25.803 0-46.72-20.917-46.72-46.72 0-25.803 20.917-46.72 46.72-46.72 25.772 0 46.676 20.869 46.72 46.64-.044 25.784-20.936 46.676-46.72 46.72z"
              />
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="geolocation__error-message">{{errorMessage}}</div>
  </div>
</template>





<style lang="scss">
$primary: #888;
$primary-hover: #555;

[v-cloak] {
  display: none;
}

.geolocation {
  opacity: 1;
  transition: all ease-out 0.2s;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  td,
  th {
    vertical-align: middle;
  }

  .geolocation__loader {
    opacity: 0;
    height: 0;
    transition: all 0.4s ease-out;
  }

  &.loading {
    transition: all ease-out 0.2s;

    > div,
    > table {
      opacity: 0;
      height: 0;
    }

    .geolocation__loader {
      transition: all 0.5s ease-out;
      opacity: 1;
      height: 60px;
    }
  }

  &__display {
    vertical-align: middle;
    padding: 0.3em 0;
    font-size: 1em;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    vertical-align: middle;
    align-items: stretch;
    align-content: center;

    &-label {
      background: transparent;
    }

    @media screen and (max-width: 500px) {
      flex-direction: column;

      &-label {
        padding: 0.5rem;
      }
    }
  }

  &__show-form {
    padding: 0 1.4rem;
    font-size: 0.7rem;
    background: transparent;
    border: none;
    outline: none;
    text-transform: uppercase;
    color: $primary;
    font-weight: 900;
    cursor: pointer;
    vertical-align: middle;

    &:hover {
      color: $primary-hover;
    }
  }

  &__error-message {
    color: red;
    font-size: 0.8em;
    padding: 0.5em 0;
  }

  &-control {
    width: 100%;
    border-radius: 5px;
    background: #fff;
    vertical-align: middle;
    border: 1px solid #ccc;
    max-width: 400px;
    margin: 0 auto;

    &__placeSearch {
      &-input,
      input[type='search'] {
        font-size: 1.1em;
        line-height: 2;
        width: 100%;
        border: 0;
        outline: none;
        box-sizing: border-box;
        box-shadow: none;
        border-color: #fff;
        padding: 8px 0 8px 10px;
        margin: 0;
        color: #222;
        text-align: left;
        text-overflow: ellipsis;
      }
    }

    &__detectLocation {
      text-align: right;
      width: 30px;
      vertical-align: middle;

      &-button {
        width: 25px;
        height: 25px;
        cursor: pointer;
        margin: 2px 6px;
        text-align: right;
        fill: #999;
        transition: all 0.25s ease-out;

        &:hover {
          fill: #555;
          .crosshair__line {
            fill: #000;
          }
        }

        &.processing {
          .crosshair__center,
          .crosshair__line {
            animation: pulse-crosshair 0.5s infinite;
          }
        }
      }
    }
  }
}

.ring-loader {
  display: block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0px auto;
  z-index: 11;

  -webkit-animation: ring-loader__fadein 0.4s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: ring-loader__fadein 0.4s; /* Firefox < 16 */
  -o-animation: ring-loader__fadein 0.4s; /* Opera < 12.1 */
  animation: ring-loader__fadein 0.4s;

  &:before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  &__circle {
    -webkit-animation: ring-loader__rotate 1s linear infinite, opacity 0.1s ease-out;
    animation: ring-loader__rotate 1s linear infinite, opacity 0.1s ease-out;
    height: 100%;
    -webkit-transform-origin: center center;
    -ms-transform-origin: center center;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
    z-index: 12;

    &-quarter {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 51px;
      height: 51px;
      margin: 6px;
      border: 3px solid $primary;
      border-radius: 50%;
      animation: ring-loader__rotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: $primary transparent transparent transparent;

      &:nth-child(1) {
        animation-delay: -0.45s;
      }

      &:nth-child(2) {
        animation-delay: -0.3s;
      }

      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }
  }
}

@keyframes ring-loader__rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes ring-loader__fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pulse-crosshair {
  0% {
    fill: #444;
  }
  100% {
    fill: #bbb;
  }
}

.pac-container:after {
  //illegally remove 'powered by Google' in places autocomplete
  content: none !important;
  background-image: none !important;
  height: 0px;
}
</style>
